import React from "react";

const Error = () => {
  return (
    <div>
      <h3>Error</h3>
      <p>
        This page does not exists, Please go to{" "}
        <a href="https://timurgolovinov.com/"> timurgolovinov.com</a>
      </p>
    </div>
  );
};

export default Error;
